// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fraction_enum_40150981 */
var FractionEnum40150981;
(function (FractionEnum40150981) {
    FractionEnum40150981["Supernatant"] = "Supernatant";
    FractionEnum40150981["Pellet"] = "Pellet";
    FractionEnum40150981["Dry powder"] = "Dry powder";
    FractionEnum40150981["Cream"] = "Cream";
    FractionEnum40150981["Broth"] = "Broth";
})(FractionEnum40150981 || (FractionEnum40150981 = {}));
;
export default FractionEnum40150981;
/** Zod schema for fraction_enum_40150981 */
export const fractionEnum40150981 = z.nativeEnum(FractionEnum40150981);
//# sourceMappingURL=FractionEnum40150981.js.map